import {
    setSliceRecordStatus,
    setSliceRecorderFrequency,
    setSliceRecorderDeviceList,
    setSliceRecorderDeviceId,
    setSliceRecorderDuration,
    setSliceIsShowRecorderDelay,
    setSliceAudioUrl,
    setSliceAudioName,
} from '../slices/FJSliceRecord.js';
import FJConstant from '../../constants/FJConstant.js';
import FJRecorder from '../../lib/FJRecorder.js';
import FJWaveform from '../../lib/FJWaveform.js';
import FJUtil from '../../util/FJUtil.js';
const __getRecorderDeviceList = async () => {
    if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
    }
    // eslint-disable-next-line no-useless-catch
    try {
        if (navigator.mediaDevices.getUserMedia === undefined) {
            navigator.mediaDevices.getUserMedia = function (constraints) {
                // 首先，如果有getUserMedia的话，就获得它
                const getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

                // 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
                if (!getUserMedia) {
                    throw new Error('No Support');
                }

                // 否则，为老的navigator.getUserMedia方法包裹一个Promise
                return new Promise(function (resolve, reject) {
                    getUserMedia.call(navigator, constraints, resolve, reject);
                });
            };
        }

        if (!navigator.mediaDevices.getUserMedia) {
            throw new Error('No Support');
        }

        await navigator.mediaDevices.getUserMedia({ audio: true });
        const devices = await navigator.mediaDevices.enumerateDevices();

        return devices
            .filter(item => {
                return item.kind === 'audioinput' && item.deviceId !== '' && item.label !== '';
            })
            .map(item => {
                return {
                    id: item.deviceId,
                    text: item.label,
                };
            });
    } catch (e) {
        throw e;
    }
};

let _fPreviewRecorder = null;
let _fDrawTimeout = null;
let _fRecorder = null;
let _fUseInputData = [];
let _fBufferSize = 0;
let _fRecorderDuration = 0;

const FJActionAIAudioGenerator = {
    setAudioUrlAction: function (url) {
        return dispatch => {
            dispatch(setSliceAudioUrl(url));
        };
    },
    setAudioNameAction: function (name) {
        return dispatch => {
            dispatch(setSliceAudioName(name));
        };
    },
    setIsShowRecorderDelayAction: function (bool) {
        return dispatch => {
            dispatch(setSliceIsShowRecorderDelay(bool));
        };
    },
    setRecordStatusAction: function (status) {
        return dispatch => {
            dispatch(setSliceRecordStatus(status));
        };
    },
    setRecorderFrequencyAction: function (data) {
        return dispatch => {
            dispatch(setSliceRecorderFrequency(data));
        };
    },
    setRecorderDeviceListAction: function (list) {
        return dispatch => {
            dispatch(setSliceRecorderDeviceList(list));
        };
    },
    setRecorderDeviceIdAction: function (status) {
        return dispatch => {
            dispatch(setSliceRecorderDeviceId(status));
        };
    },
    setRecorderDurationAction: function (duration) {
        return dispatch => {
            dispatch(setSliceRecorderDuration(duration));
        };
    },

    initRecorderAction: function () {
        return async dispatch => {
            dispatch(this.setRecordStatusAction(FJConstant.DEFAULT));
            try {
                const list = await __getRecorderDeviceList();
                if (list && list.length > 0) {
                    dispatch(this.setRecorderDeviceListAction(list));
                    dispatch(this.setRecorderDeviceIdAction(list[0]?.id));
                    const audioDeviceId = list[0]?.id;
                    dispatch(this.startPreviewRecorderAction(audioDeviceId));
                } else {
                    dispatch(this.setRecordStatusAction(FJConstant.NO_DEVICE_LIST));
                }
            } catch (e) {
                dispatch(this.setRecordStatusAction(FJConstant.NO_PERMISSION));
                dispatch(this.setRecorderDeviceListAction([]));
                dispatch(this.setRecorderDeviceIdAction(null));
            }
        };
    },

    startPreviewRecorderAction: function (audioDeviceId) {
        return dispatch => {
            const constraints = {
                audio: {
                    deviceId: audioDeviceId,
                },
            };
            try {
                _fPreviewRecorder = new FJRecorder();
                _fPreviewRecorder.previewRecorder(constraints, {
                    callback: () => {
                        const __draw = () => {
                            const frequencyAudioContext = _fPreviewRecorder.frequencyAudioContext;
                            let dataArray = new Uint8Array(frequencyAudioContext.analyser.frequencyBinCount);
                            frequencyAudioContext.analyser.getByteFrequencyData(dataArray);
                            for (let i = 0; i < dataArray.length; i += 32) {
                                const frequency = dataArray[i] / 256;
                                dispatch(this.setRecorderFrequencyAction(frequency));
                            }
                            _fDrawTimeout = requestAnimationFrame(__draw);
                        };
                        __draw();
                    },
                    failCallback: error => {
                        dispatch(this.dealRecorderErrorAction(error));
                    },
                });
            } catch (error) {
                console.log('error:::', error);
            }
        };
    },

    stopPreviewRecorder: function () {
        _fPreviewRecorder?.stopPreviewRecorder();
        if (_fDrawTimeout) {
            cancelAnimationFrame(_fDrawTimeout);
            _fDrawTimeout = null;
        }

        if (_fPreviewRecorder) {
            _fPreviewRecorder = null;
        }
    },

    /**
     * @description 开始录音
     * @returns {(function())|*}
     */
    startRecorderAction: function (container) {
        return (dispatch, getState) => {
            dispatch(this.setAudioUrlAction(''));
            dispatch(this.setRecordStatusAction(FJConstant.RECORDING));

            const audioDeviceId = getState().record.recorderDeviceId;
            const constraints = {
                audio: {
                    deviceId: audioDeviceId,
                },
            };

            try {
                _fRecorder = new FJRecorder();
                const waveform = new FJWaveform({
                    waveColor: 'rgba(160, 169, 207, 1)',
                    backgroundColor: '#f2f3f7',
                    ratioOfTimeToPixels: 100,
                    container: container,
                    canvasWidth: 3000,
                    canvasHeight: 42,
                    isNeedUpdateCanvasPosition: true,
                });
                _fRecorder.startRecorder(constraints, {
                    onProgress: e => {
                        const inputBuffer = e.inputBuffer;
                        const inputData = inputBuffer.getChannelData(0);
                        _fUseInputData.push({
                            inputData: new Float32Array(inputData),
                            duration: inputBuffer.duration,
                            isRender: false,
                        });
                        _fBufferSize += inputData.length;
                        _fRecorderDuration += inputBuffer.duration;
                        dispatch(this.setRecorderDurationAction(_fRecorderDuration));
                        if (_fRecorderDuration >= FJUtil.getRecordMaxDuration()) {
                            dispatch(this.stopRecorderAction());
                        }

                        // 不清除已经生成的波形图，也不重新渲染已有的波形图
                        waveform.drawRealTimeWaveform(inputBuffer);
                    },
                    failCallback: error => {
                        dispatch(this.dealRecorderErrorAction(error));
                    },
                });
            } catch (error) {
                console.log('error:::', error);
            }
        };
    },

    /**
     * @description 停止录制
     * @returns {(function(*))|*}
     */
    stopRecorderAction: function (isOnlyStop = false) {
        return async dispatch => {
            _fRecorder?.stopRecorder();
            if (
                _fUseInputData &&
                _fUseInputData.length > 0 &&
                !isOnlyStop &&
                _fRecorderDuration >= FJUtil.getRecordMinDuration()
            ) {
                let mergedBuffer = new Float32Array(_fBufferSize);
                let offset = 0;
                _fUseInputData.forEach(item => {
                    mergedBuffer.set(item.inputData, offset);
                    offset += item.inputData.length;
                });
                const _getFileName = () => {
                    const now = new Date();
                    // 获取年、月、日、时、分、秒
                    const year = now.getFullYear();
                    const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并补零
                    const day = String(now.getDate()).padStart(2, '0'); // 补零
                    const hours = String(now.getHours()).padStart(2, '0'); // 补零
                    const minutes = String(now.getMinutes()).padStart(2, '0'); // 补零
                    const seconds = String(now.getSeconds()).padStart(2, '0'); // 补零

                    // 格式化日期和时间为 2024-07-17T111525
                    return `Voice recording-${year}-${month}-${day}T${hours}${minutes}${seconds}.mp3`;
                };
                const fileName = _getFileName();
                dispatch(this.setAudioNameAction(fileName));
                dispatch(this.setRecordStatusAction(FJConstant.SUCCESS));
                const mp3Data = await FJUtil.encodeMp3(mergedBuffer);
                if (mp3Data) {
                    const mimeType = 'audio/mpeg';
                    const blob = new Blob(mp3Data, { type: mimeType });
                    const audioFile = new File([blob], fileName, { type: mimeType });
                    const audioUrl = URL.createObjectURL(audioFile);
                    dispatch(this.setAudioUrlAction(audioUrl));
                }

                _fBufferSize = 0;
                _fUseInputData = [];
                mergedBuffer = null;

                _fRecorderDuration = 0;
                dispatch(this.setRecorderDurationAction(_fRecorderDuration));
            } else {
                console.log('else');
                _fBufferSize = 0;
                _fUseInputData = [];
                _fRecorderDuration = 0;
                dispatch(this.setRecorderDurationAction(_fRecorderDuration));
            }
        };
    },

    dealRecorderErrorAction: function (error) {
        return dispatch => {
            if (error === 'No Support') {
                console.log('No Support');
            } else if (error === 'ended') {
                dispatch(this.setRecordStatusAction(FJConstant.NO_PERMISSION));
                dispatch(this.setRecorderDeviceListAction([]));
                this.stopPreviewRecorder();
                dispatch(this.stopRecorderAction());

                return;
            }
            const { name } = error;
            let errorMessage;
            switch (name) {
                // 用户拒绝
                case 'NotAllowedError':
                case 'PermissionDeniedError':
                    dispatch(this.setRecordStatusAction(FJConstant.NO_PERMISSION));
                    break;
                // 没接入录音设备
                case 'NotFoundError':
                case 'DevicesNotFoundError':
                case 'OverConstrainedError':
                    errorMessage = '录音设备未找到';
                    dispatch(this.setRecordStatusAction(FJConstant.NO_DEVICE_LIST)); // 统一当做录音设备没有处理
                    break;
                // 其它错误
                case 'NotSupportedError':
                    errorMessage = '不支持录音功能';
                    dispatch(this.setRecordStatusAction(FJConstant.NO_DEVICE_LIST)); // 统一当做录音设备没有处理
                    break;
                default:
                    errorMessage = '录音调用错误';
                    dispatch(this.setRecordStatusAction(FJConstant.NO_DEVICE_LIST)); // 统一当做录音设备没有处理
            }
            console.log(errorMessage);
        };
    },
};

export default FJActionAIAudioGenerator;
